module.exports = __webpack_public_path__ + "static/media/PDF_131.cb48df69.pdf";